// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__2EPOP","emails":"CreateEditClinics_emails__22lBE","emailTagLabel":"CreateEditClinics_emailTagLabel__3CZ2-"};